import React from 'react';

const MinusWcag = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 523.16 523.16"><defs><clipPath id="clip-path" transform="translate(0 0)"><rect class="cls-1" width="523.16" height="523.16"/></clipPath></defs><title>Mniejszy rozmiar czcionki</title><g id="Warstwa_2" data-name="Warstwa 2"><g id="Warstwa_1-2" data-name="Warstwa 1"><g class="cls-2"><path class="cls-3" d="M446.55,76.62A261.58,261.58,0,0,0,76.61,446.55,261.58,261.58,0,0,0,446.55,76.62m-7,220h-356v-70h356Z" transform="translate(0 0)"/></g></g></g></svg>
    )
}

export default MinusWcag;